import { render, staticRenderFns } from "./B2CAffiliate.vue?vue&type=template&id=aa12af1a"
import script from "./B2CAffiliate.vue?vue&type=script&lang=js"
export * from "./B2CAffiliate.vue?vue&type=script&lang=js"
import style0 from "./B2CAffiliate.vue?vue&type=style&index=0&id=aa12af1a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports